export function viewportCenterXInTrackSpace(viewportWidth: number, translateX: number): number {
	return viewportWidth / 2 - translateX;
}

export function focusToFloatIndex(focusXInTrack: number, slideCenterXs: number[]): number {
	const n = slideCenterXs.length;
	if (n <= 1) return 0;
	if (focusXInTrack <= slideCenterXs[0]) return 0;
	if (focusXInTrack >= slideCenterXs[n - 1]) return n - 1;
	for (let i = 0; i < n - 1; i++)
		if (focusXInTrack <= slideCenterXs[i + 1]) {
			const left = slideCenterXs[i];
			const right = slideCenterXs[i + 1];
			const span = right - left;
			const t = span > 0 ? (focusXInTrack - left) / span : 0;
			return i + t;
		}

	return n - 1;
}

export function floatIndexToFocusX(floatIndex: number, slideCenterXs: number[]): number {
	if (!slideCenterXs.length) return 0;
	if (slideCenterXs.length === 1) return slideCenterXs[0];
	const last = slideCenterXs.length - 1;
	const clamped = Math.max(0, Math.min(last, floatIndex));
	const i = Math.floor(clamped);
	const t = clamped - i;
	if (i >= last) return slideCenterXs[last];
	const left = slideCenterXs[i];
	const right = slideCenterXs[i + 1];
	const span = right - left;
	return span > 0 ? left + t * span : left;
}
